import { render, staticRenderFns } from "./TravelDetails.vue?vue&type=template&id=02e3e883&scoped=true&"
import script from "./TravelDetails.vue?vue&type=script&lang=js&"
export * from "./TravelDetails.vue?vue&type=script&lang=js&"
import style0 from "./TravelDetails.vue?vue&type=style&index=0&id=02e3e883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3e883",
  null
  
)

export default component.exports